"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Briefcase, Users, TrendingUp, Award } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const solutions = [{
  id: 1,
  title: "A True Values-Based and Skills Match",
  description: "Our unique recruitment methodology goes beyond qualifications. We focus on cultural and values match, ensuring that every candidate is right for the organisation and the people you care for and support.",
  icon: Briefcase,
  image: "https://activatepeople.co.uk/wp-content/uploads/2025/11/Values-1.png"
}, {
  id: 2,
  title: "Psychometrics for Smarter Recruitment",
  description: "We use evidence-based assessment to identify and engage candidates with resilience, decision-making, and people leadership skills and who\xA0who align with care values.",
  icon: Users,
  image: "https://optimum-imp.10web.cloud/wp-content/uploads/2025/11/CC-3-Primary-logo-on-blue.png"
}, {
  id: 3,
  title: "Exclusive Recruitment Tools",
  description: "We equip organisations and candidates with cutting-edge hiring insights, leadership resources, and sector-specific best practices to enhance the recruitment and onboarding experience.",
  icon: TrendingUp,
  image: "https://activatepeople.co.uk/wp-content/uploads/2025/11/Tools.png"
}, {
  id: 4,
  title: "Specialised Retention Interviews",
  description: "We provide structured retention interviews at key milestones to ensure a smooth transition, uncover any challenges early, and strengthen long-term retention.",
  icon: Award,
  image: "https://activatepeople.co.uk/wp-content/uploads/2025/11/Retention.png"
}];
export default function ExploreOurSpecializedSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section ref={ref} className="relative overflow-hidden bg-page-background text-foreground-page py-16 md:py-24">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 35px,
            hsl(0, 0%, 100%) 35px,
            hsl(0, 0%, 100%) 36px
          )`,
      animation: "drift 40s linear infinite"
    }} />
      <style jsx>{`
        @keyframes drift {
          from {
            transform: translateX(0) translateY(0);
          }
          to {
            transform: translateX(50px) translateY(50px);
          }
        }
      `}</style>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4 text-foreground-page">
            Explore Our Specialised Solutions
          </h2>
          <p className="text-foreground-page text-lg">
            Combining social care expertise and proactive headhunting to
            individual roles and projects
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-8">
          {solutions.map((solution, i) => {
          const Icon = solution.icon;
          const delay = i * 100;
          return <Card key={solution.id} data-index={i} className={`card transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-strong ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: isVisible ? `${delay}ms` : "0ms"
          }}>
                <img src={solution.image} alt={solution.title} className="w-full h-48 object-cover rounded-t-xl" />
                <CardHeader className="pb-3">
                  <div className="flex items-center gap-3">
                    <div className="p-2.5 rounded-md bg-primary/10 text-primary transition-colors duration-[var(--duration-medium)] group-hover:bg-accent group-hover:text-foreground-accent">
                      <Icon className="size-6" />
                    </div>
                    <CardTitle className="text-xl text-foreground">
                      {solution.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-foreground text-sm leading-relaxed">
                    {solution.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="text-center">
          
        </div>
      </div>
    </section>;
}